export const calculatePercentageHelper = (a: number, b: number): number => (a / b) * 100 || 0;
